
        window.initMatches = window.initMatches ? window.initMatches : [];
        window.initMatches.push(function (bh) {
          window.matches = window.matches ? window.matches : [];
          window.matches["../blocks.01-base/bh/bh.bh.js"] = window.matches["../blocks.01-base/bh/bh.bh.js"] || require("../blocks.01-base/bh/bh.bh.js")(bh) || true;
window.matches["../blocks.01-base/page/page.bh.js"] = window.matches["../blocks.01-base/page/page.bh.js"] || require("../blocks.01-base/page/page.bh.js")(bh) || true;
window.matches["../blocks.01-base/page/__ua/page__ua.bh.js"] = window.matches["../blocks.01-base/page/__ua/page__ua.bh.js"] || require("../blocks.01-base/page/__ua/page__ua.bh.js")(bh) || true;
window.matches["../blocks.01-base/header/header.bh.js"] = window.matches["../blocks.01-base/header/header.bh.js"] || require("../blocks.01-base/header/header.bh.js")(bh) || true;
window.matches["../blocks.01-base/1px/1px.bh.js"] = window.matches["../blocks.01-base/1px/1px.bh.js"] || require("../blocks.01-base/1px/1px.bh.js")(bh) || true;
window.matches["../blocks.01-base/img/img.bh.js"] = window.matches["../blocks.01-base/img/img.bh.js"] || require("../blocks.01-base/img/img.bh.js")(bh) || true;
window.matches["../blocks.01-base/img/_lazy/img_lazy.bh.js"] = window.matches["../blocks.01-base/img/_lazy/img_lazy.bh.js"] || require("../blocks.01-base/img/_lazy/img_lazy.bh.js")(bh) || true;
window.matches["../blocks.01-base/fi/fi.bh.js"] = window.matches["../blocks.01-base/fi/fi.bh.js"] || require("../blocks.01-base/fi/fi.bh.js")(bh) || true;
window.matches["../blocks.01-base/a/a.bh.js"] = window.matches["../blocks.01-base/a/a.bh.js"] || require("../blocks.01-base/a/a.bh.js")(bh) || true;
window.matches["../blocks.01-base/main/main.bh.js"] = window.matches["../blocks.01-base/main/main.bh.js"] || require("../blocks.01-base/main/main.bh.js")(bh) || true;
window.matches["../blocks.01-base/footer/footer.bh.js"] = window.matches["../blocks.01-base/footer/footer.bh.js"] || require("../blocks.01-base/footer/footer.bh.js")(bh) || true;
window.matches["../blocks.02-common/image/image.bh.js"] = window.matches["../blocks.02-common/image/image.bh.js"] || require("../blocks.02-common/image/image.bh.js")(bh) || true;
window.matches["../blocks.02-common/form-control/form-control.bh.js"] = window.matches["../blocks.02-common/form-control/form-control.bh.js"] || require("../blocks.02-common/form-control/form-control.bh.js")(bh) || true;
window.matches["../blocks.02-common/btn/btn.bh.js"] = window.matches["../blocks.02-common/btn/btn.bh.js"] || require("../blocks.02-common/btn/btn.bh.js")(bh) || true;
window.matches["../blocks.02-common/form-check/form-check.bh.js"] = window.matches["../blocks.02-common/form-check/form-check.bh.js"] || require("../blocks.02-common/form-check/form-check.bh.js")(bh) || true;
window.matches["../blocks.02-common/form-check/__input/form-check__input.bh.js"] = window.matches["../blocks.02-common/form-check/__input/form-check__input.bh.js"] || require("../blocks.02-common/form-check/__input/form-check__input.bh.js")(bh) || true;
window.matches["../blocks.02-common/form-check/__label/form-check__label.bh.js"] = window.matches["../blocks.02-common/form-check/__label/form-check__label.bh.js"] || require("../blocks.02-common/form-check/__label/form-check__label.bh.js")(bh) || true;
        });
require("../blocks.01-base/bh/bh.js");
require("../blocks.01-base/page/page.js");
require("../blocks.01-base/page/__alert/page__alert.scss");
require("../blocks.01-base/page/__ua/page__ua.scss");
require("../blocks.01-base/img/img.scss");
require("../blocks.01-base/fi/fi.scss");
require("../blocks.01-base/a/a.scss");
require("../blocks.02-common/lightgallery/lightgallery.scss");
require("../blocks.02-common/swiper/swiper.scss");
require("../blocks.02-common/font-als-gorizont/font-als-gorizont.scss");
require("../blocks.02-common/font-als-hauss/font-als-hauss.scss");
require("../blocks.02-common/lazysizes/lazysizes.js");
require("../blocks.02-common/image/image.scss");
require("../blocks.02-common/image/__inner/image__inner.scss");
require("../blocks.02-common/tom-select/tom-select.scss");
require("../blocks.02-common/image/_align/image_align.scss");
require("../blocks.03-bootstrap/bootstrap/bootstrap.scss");
require("../blocks.03-bootstrap/bootstrap/bootstrap.js");
require("../blocks.03-bootstrap/alert/alert.scss");
require("../blocks.03-bootstrap/badge/badge.scss");
require("../blocks.03-bootstrap/buttons/buttons.scss");
require("../blocks.03-bootstrap/collapse/collapse.js");
require("../blocks.03-bootstrap/dropdown/dropdown.scss");
require("../blocks.03-bootstrap/modal/modal.scss");
require("../blocks.03-bootstrap/modal/modal.js");
require("../blocks.03-bootstrap/offcanvas/offcanvas.js");
require("../blocks.03-bootstrap/tab/tab.js");
require("../blocks.03-bootstrap/tooltip/tooltip.scss");
require("../blocks.03-bootstrap/tooltip/tooltip.js");
require("../blocks.03-bootstrap/type/type.scss");
require("../blocks.04-project/basket/basket.js");
require("../blocks.04-project/compare/compare.js");
require("../blocks.04-project/favorite/favorite.js");
require("../blocks.04-project/inputmask/inputmask.js");
require("../blocks.04-project/counter/counter.scss");
require("../blocks.04-project/counter/counter.js");
require("../blocks.04-project/custom-scrollbar/custom-scrollbar.scss");
require("../blocks.04-project/custom-scrollbar/custom-scrollbar.js");
require("../blocks.04-project/gift-popper/gift-popper.scss");
require("../blocks.04-project/page/page.scss");
require("../blocks.04-project/page/page.js");
require("../blocks.04-project/animation/animation.scss");
require("../blocks.04-project/animation/animation.js");
require("../blocks.04-project/copy/copy.js");
require("../blocks.04-project/gift-set-control/gift-set-control.scss");
require("../blocks.04-project/gift-set-control/gift-set-control.js");
require("../blocks.04-project/lazy-init/lazy-init.js");
require("../blocks.04-project/light-gallery/light-gallery.scss");
require("../blocks.04-project/light-gallery/light-gallery.js");
require("../blocks.04-project/loader/loader.scss");
require("../blocks.04-project/product-control/product-control.scss");
require("../blocks.04-project/product-control/product-control.js");
require("../blocks.04-project/scroll-to/scroll-to.scss");
require("../blocks.04-project/skeleton/skeleton.scss");
require("../blocks.04-project/user-rest/user-rest.js");
require("../blocks.04-project/validation/validation.scss");
require("../blocks.04-project/validation/validation.js");
require("../blocks.04-project/wysiwyg/wysiwyg.scss");
require("../blocks.04-project/wysiwyg/wysiwyg.js");
require("../blocks.04-project/header/header.scss");
require("../blocks.04-project/header/header.js");
require("../blocks.04-project/form-control/form-control.scss");
require("../blocks.04-project/product-card/product-card.scss");
require("../blocks.04-project/product-card/product-card.js");
require("../blocks.04-project/search/search.scss");
require("../blocks.04-project/search/search.js");
require("../blocks.04-project/product-card-slider/product-card-slider.js");
require("../blocks.04-project/title-collapse/title-collapse.scss");
require("../blocks.04-project/main/main.scss");
require("../blocks.04-project/breadcrumbs/breadcrumbs.scss");
require("../blocks.04-project/breadcrumbs/breadcrumbs.js");
require("../blocks.04-project/input-control/input-control.scss");
require("../blocks.04-project/input-control/input-control.js");
require("../blocks.04-project/form-check/form-check.scss");
require("../blocks.04-project/custom-select/custom-select.scss");
require("../blocks.04-project/custom-select/custom-select.js");
require("../blocks.04-project/file-control/file-control.scss");
require("../blocks.04-project/file-control/file-control.js");
require("../blocks.04-project/tabs/tabs.scss");
require("../blocks.04-project/tabs/tabs.js");
require("../blocks.04-project/tip/tip.scss");
require("../blocks.04-project/slider-navigation/slider-navigation.scss");
require("../blocks.04-project/product-small-slider/product-small-slider.scss");
require("../blocks.04-project/product-small-slider/product-small-slider.js");
require("../blocks.04-project/gift-set-slider/gift-set-slider.scss");
require("../blocks.04-project/gift-set-slider/gift-set-slider.js");
require("../blocks.04-project/gift-set/gift-set.scss");
require("../blocks.04-project/gift-set/gift-set.js");
require("../blocks.04-project/gift-set-card/gift-set-card.scss");
require("../blocks.04-project/gift-set-card/gift-set-card.js");
require("../blocks.04-project/product-slider/product-slider.scss");
require("../blocks.04-project/product-slider/product-slider.js");
require("../blocks.04-project/slider-pagination/slider-pagination.scss");
require("../blocks.04-project/slider-pagination/slider-pagination.js");
require("../blocks.04-project/evaluation-slider/evaluation-slider.scss");
require("../blocks.04-project/evaluation-slider/evaluation-slider.js");
require("../blocks.04-project/evaluation-card/evaluation-card.scss");
require("../blocks.04-project/stars-rating/stars-rating.scss");
require("../blocks.04-project/stars-rating/stars-rating.js");
require("../blocks.04-project/content-slider/content-slider.scss");
require("../blocks.04-project/content-slider/content-slider.js");
require("../blocks.04-project/product-card-row/product-card-row.scss");
require("../blocks.04-project/product-card-row/product-card-row.js");
require("../blocks.04-project/news-card/news-card.scss");
require("../blocks.04-project/catalogue-card/catalogue-card.scss");
require("../blocks.04-project/gift-set-cart/gift-set-cart.scss");
require("../blocks.04-project/product-card-cart/product-card-cart.scss");
require("../blocks.04-project/promotion/promotion.scss");
require("../blocks.04-project/grid-row/grid-row.scss");
require("../blocks.04-project/footer/footer.scss");
require("../blocks.04-project/map-styles/map-styles.scss");
require("../blocks.04-project/availability-map/availability-map.scss");
require("../blocks.04-project/availability-map/availability-map.js");